import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface InfoCardProps {
  icon?: LucideIcon;
  title: string;
  value?: string;
  description: string;
  variant?: "default" | "highlight" | "outline";
}

const variantStyles = {
  default: "bg-card border border-border",
  highlight: "bg-accent/10 border border-accent/20",
  outline: "bg-transparent border-2 border-border",
};

const InfoCard = ({ icon: Icon, title, value, description, variant = "default" }: InfoCardProps) => (
  <div className={cn("p-7 md:p-8 space-y-4 transition-all duration-300 hover:shadow-md", variantStyles[variant])}>
    {Icon && (
      <div className="w-12 h-12 flex items-center justify-center bg-accent/10 text-accent">
        <Icon className="w-6 h-6" />
      </div>
    )}
    {value && (
      <p className="font-headline text-3xl md:text-4xl text-foreground">{value}</p>
    )}
    <h4 className="font-headline text-lg text-foreground">{title}</h4>
    <p className="text-muted-foreground text-base leading-relaxed">{description}</p>
  </div>
);

export default InfoCard;
